/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The BagusageCreateBagUsageParam model module.
 * @module model/BagusageCreateBagUsageParam
 * @version 1.0
 */
class BagusageCreateBagUsageParam {
    /**
     * Constructs a new <code>BagusageCreateBagUsageParam</code>.
     * @alias module:model/BagusageCreateBagUsageParam
     */
    constructor() { 
        
        BagusageCreateBagUsageParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BagusageCreateBagUsageParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BagusageCreateBagUsageParam} obj Optional instance to populate.
     * @return {module:model/BagusageCreateBagUsageParam} The populated <code>BagusageCreateBagUsageParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BagusageCreateBagUsageParam();

            if (data.hasOwnProperty('bagType')) {
                obj['bagType'] = ApiClient.convertToType(data['bagType'], 'String');
            }
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('orgId')) {
                obj['orgId'] = ApiClient.convertToType(data['orgId'], 'Number');
            }
            if (data.hasOwnProperty('quantity')) {
                obj['quantity'] = ApiClient.convertToType(data['quantity'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} bagType
 */
BagusageCreateBagUsageParam.prototype['bagType'] = undefined;

/**
 * @member {String} date
 */
BagusageCreateBagUsageParam.prototype['date'] = undefined;

/**
 * @member {Number} orgId
 */
BagusageCreateBagUsageParam.prototype['orgId'] = undefined;

/**
 * @member {Number} quantity
 */
BagusageCreateBagUsageParam.prototype['quantity'] = undefined;






export default BagusageCreateBagUsageParam;

